import { AppGestorBypassResponse } from './app-gestor-bypass-response.model';

/**
 * Resposta de `POST /api/Swap/GravarSessao` (corresponde ao C#
 * `SwapGravarSessaoResponseViewModel`).
 *
 * Cobre dois cenários (sempre verificar `codRetorno` / `proximaEtapa`):
 *  - `0200` + `'PRE_AUTORIZACAO'`: sessão de autorização manual criada normalmente.
 *  - `0409` + `'SESSAO_EXISTENTE'`: sessão duplicada — apenas
 *    `sessionId`, `sessionExterna` e `codSessao` vêm preenchidos. O
 *    backend **não aplica** bypass nesse caso (o front retenta com
 *    novo `dscSessionExterna`).
 *
 * Erros `0422` (validação) e `0500` (interno) viram exception no
 * backend e chegam aqui como HTTP 4xx/5xx (use `catchError`).
 *
 * Campo {@link bypass}:
 *  - `null` → `bypass=false` no request: usuário não pediu bypass.
 *  - `!null` → `bypass=true` no request: bypass foi tentado;
 *    `bypass.flgSucesso` indica se aplicou ou não.
 */
export interface SwapGravarSessaoResponse {
  flgSucesso: boolean;
  /** '0200' = sucesso; '0409' = sessão duplicada. */
  codRetorno: string;
  dscRetorno?: string;
  /** 'PRE_AUTORIZACAO' | 'SESSAO_EXISTENTE'. */
  proximaEtapa: string;

  sessionId?: string;
  sessionExterna?: string;
  codSessao?: number | null;

  codFrota?: number | null;
  codVeiculo?: number | null;
  dscPlaca?: string | null;
  codMotorista?: number | null;

  codProduto?: number | null;
  cdProduto?: string | null;

  vlrPrecoUnitario?: number | null;
  qtdVolume?: number | null;
  vlrTotal?: number | null;
  numKm?: number | null;

  /** ISO datetime. (Nome mantido fiel à coluna `DAT_VALIDADE_PREAUTORIZACAO`.) */
  datValidadePreautorizacao?: string | null;
  vlrMinimo?: number | null;
  vlrMaximo?: number | null;

  jsonFrotasCandidatas?: string | null;
  codAcesso?: number | null;

  /**
   * Resultado do bypass quando `request.bypass === true`.
   * `null` quando o bypass não foi solicitado.
   */
  bypass?: AppGestorBypassResponse | null;
}
